<template>
    <div class="picture">
        <div class="headTitle">
            <div class="shadowTxt">ALBUM</div>
            <div class="title">品牌画册</div>
        </div>
        <div class="imgPart">
            <div class="imgBox" v-for="(item, idx) in cards"
            :key="`${idx}`"
            @click="handle(item)">
                <img :src="item.photo" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import { apiGetPaintings } from '../../api/index'

export default{
    metaInfo: {
        title: '品牌画册-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
    data() {
        return {
        cards: [],
        };
    },
    methods: {
        handle(item) {
        window.open("http://www.weaiove.com" + item.pdffile, 'blank')
        },
       
        getCards() {
            apiGetPaintings().then((res) => {
                res.data.painting.forEach((item) => {
                item.photo = "http://www.weaiove.com" + item.photo;
                });
                this.cards = res.data.painting;
            });
        },
    },
    created() {
        this.getCards();
    },
}
</script>

<style scoped lang='less'>
*{
    margin: 0;
    padding: 0;
}
img{
    width: 100%;
}
.headTitle{
    padding: 20px 15px 7px 15px;
    background: #fff;
    .shadowTxt{
        font-size: 40px;
        line-height: 47px;
        color: #F8F8F8;
        font-family: 'DIN Alternate Bold';
        font-weight: bold;
    }
    .title{
        color: #222;
        font-size: 18px;
        line-height: 25px;
        font-family: '苹方-简 中黑体';
        font-weight: 600;
        margin-top: -28px;
    }
    .text{
        color: #666666;
        font-size: 13px;
        line-height: 20px;
        font-family: '苹方-简 常规体';
        margin-top: 9px;
    }
}
.imgPart{
    padding: 12px 0px 30px 15px;
    overflow: hidden;
    .imgBox{
        width: 170px;
        height: 208.68px;
        margin: 0 10px 10px 0;
        float: left;
        &:nth-child(2n){
            margin-right: 0;
        }
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>